var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSilvercheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 35,
    viewBox: "0 0 48 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1939 34.753C17.3942 34.7525 16.6246 34.4486 16.0401 33.9029L1.38188 20.2139C0.786981 19.6386 0.44197 18.8527 0.420942 18.0254C0.399914 17.1981 0.704671 16.3956 1.26957 15.7908C1.83448 15.186 2.61415 14.8274 3.44096 14.792C4.26777 14.7567 5.07553 15.0475 5.68999 15.6018L18.0181 27.1119L41.8179 1.137C42.0962 0.824328 42.4337 0.569934 42.8111 0.388952C43.1885 0.207971 43.5981 0.104018 44.0162 0.0828C44.4342 0.0615815 44.8523 0.123582 45.2461 0.265417C45.6399 0.407253 46.0016 0.626083 46.3101 0.908972C46.6186 1.19186 46.8677 1.5333 47.043 1.91337C47.2183 2.29343 47.3166 2.70455 47.3316 3.12284C47.3466 3.54112 47.2781 3.95802 47.1304 4.34965C46.9827 4.74127 46.7587 5.09963 46.4712 5.40384L20.5249 33.73C20.2438 34.0369 19.9045 34.2848 19.5269 34.4598C19.1493 34.6347 18.7406 34.7329 18.3248 34.7488C18.2812 34.7525 18.2376 34.7539 18.1939 34.753Z",
    fill: "silver"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSilvercheck);
export default __webpack_public_path__ + "static/media/icon-silvercheck.70598806a977931c2327d3af01b648b6.svg";
export { ForwardRef as ReactComponent };